import { useEffect, useState } from "react";
import { useLayer, Arrow } from "react-laag";
import { IPopupProps } from ".";

interface IReplaceTextProps {
  popup: IPopupProps;
  onClose: () => void;
  onChange: (value: string, selectedPopup: IPopupProps) => void;
}

const ReplaceTextPopup = ({ popup, onClose, onChange }: IReplaceTextProps) => {
  const [inputValue, setInputValue] = useState<string>(popup.value);

  useEffect(() => {
    setInputValue(popup.value);
  }, [popup.value]);

  const { renderLayer, layerProps, arrowProps } = useLayer({
    isOpen: true,
    auto: true,
    placement: "top-center",
    snap: true,
    trigger: {
      getBounds: () => popup.trigger.getBoundingClientRect(),
      getParent: () => popup.trigger,
    },
  });

  return (
    <>
      {renderLayer(
        <div className="bg-neutral-100 shadow-lg w-52" {...layerProps}>
          <div className="flex flex-col">
            <div className="bg-neutral-300 p-1.5 font-semibold text-neutal-900 flex justify-between">
              <span>Exclude Text</span>
              <button
                className="text-red-500 font-bold"
                onClick={() => {
                  onChange(inputValue, popup);
                  onClose();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="p-2">
              <input
                type="text"
                className="w-full"
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value);
                }}
              />
            </div>
          </div>
          {
            // @ts-expect-error Issue with Arrow props
            <Arrow {...arrowProps} />
          }
        </div>
      )}
    </>
  );
};

export default ReplaceTextPopup;
